import { Component, inject } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';

// Layout Components
import { SidebarComponent } from './sidebar.component';
import { DrawerComponent } from './drawer';

// Services
import { SidebarService } from './sidebar/sidebar.service';
import { RouteScrollModeRuntime } from './scroll-ownership/route-scroll-mode.runtime';
import { APP_GLOBAL_TOAST_KEY } from '../shared/utils/toast.service';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    ToastModule,
    SidebarComponent,
    DrawerComponent,
  ],
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent {
  private sidebarService = inject(SidebarService);
  private routeScrollModeRuntime = inject(RouteScrollModeRuntime);

  /**
   * Sidebar width based on collapsed state
   */
  sidebarWidth = this.sidebarService.sidebarWidth;
  readonly isMobileViewport = this.sidebarService.isMobileViewport;
  readonly isMobileOverlayOpen = this.sidebarService.isMobileOverlayOpen;
  readonly activeRouteScrollMode = this.routeScrollModeRuntime.activeMode;
  readonly shellContentHeight = 'var(--app-shell-viewport-height, 100vh)';
  readonly globalToastKey = APP_GLOBAL_TOAST_KEY;

  openMobileSidebar(): void {
    this.sidebarService.openMobile();
  }
}
